import axios, { AxiosInstance } from 'axios';

export function createClient(): AxiosInstance {
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true,
  });
}
